import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../shared/services/http.service';
import { CryptoSharkService } from '../../shared/services/crypto-shark.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'modal-auth',
  templateUrl: './modal-auth.component.html',
  styleUrls: ['./modal-auth.component.scss']
})
export class ModalAuthComponent implements OnInit {

  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input('reason') reason: string = null;
  @Input() deleteTicketSelected;
  public authForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private httpService: HttpService,
    private cryptoService: CryptoSharkService,
    private alertServices: AlertService
  ) { }

  ngOnInit(): void {
    this.authForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      nip: ['', Validators.required],
    });

    
  }

  close(){this.onClose.emit()}

  public async authorize(){
    this.httpService.post(`api/user/auth`, {
      username: this.authForm.controls['username'].value,
      password: this.cryptoService.encryptSha(this.authForm.controls['password'].value),
      nip: this.cryptoService.encryptSha(this.authForm.controls['nip'].value),
    }).toPromise()
    .then((response: any) => { 
      this.onSuccess.emit({userId: response?.authId, rowId:this.deleteTicketSelected.rowId,  subId:this.deleteTicketSelected.subId});
      this.onClose.emit();
    }).catch((e) => {
      console.log(e);
      if (e.status == 400) {
        this.alertServices.errorToast(e.error.message)
      }
    })
  }
}
